var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBackArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "BackArrow_svg__a",
  width: 34,
  height: 34,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h34v34H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#BackArrow_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0A1E4C",
  d: "M17 21.214q-.284 0-.532-.088a1.24 1.24 0 0 1-.46-.301L9.49 14.308q-.39-.39-.39-.992t.39-.991.992-.39.992.39L17 17.85l5.525-5.525q.39-.39.991-.39.602 0 .992.39t.39.991-.39.992l-6.517 6.517a1.24 1.24 0 0 1-.46.3 1.6 1.6 0 0 1-.531.09"
}))));
export default SvgBackArrow;